"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saga = exports.updateState = exports.updateStorageSaga = exports.sendRequest = exports.fetchSaga = exports.fetchAuthSaga = exports.initAuthSaga = exports.refreshTokenSaga = exports.updateUserSaga = exports.getState = exports.initStore = exports.createReducers = exports.defaultState = void 0;
var effects_1 = require("redux-saga/effects");
var common_1 = require("../common");
var config_1 = require("../../config");
var signIn_1 = require("./signIn");
var signUp_1 = require("./signUp");
var useMe_1 = require("./useMe");
var signOut_1 = require("./signOut");
var storage_1 = require("../../storage");
exports.defaultState = __assign(__assign(__assign(__assign({ init: false, user: null, access: null, refresh: null, remember: false, authorized: false, loading: false, error: null, refreshResponse: null }, signIn_1.defaultState), signUp_1.defaultState), signOut_1.defaultState), useMe_1.defaultState);
/**
 * Reducer
 * */
var createReducers = function () { return (__assign(__assign(__assign(__assign(__assign({ initStore: function (state, _a) {
        var payload = _a.payload;
        Object.assign(state, payload, {
            init: true
        });
    }, update: function (state, _a) {
        var payload = _a.payload;
        Object.assign(state, payload);
    }, cancelableSagaError: function () {
        // trigger action cancelableSagaError
    }, notValidAction: function (_, _a) {
        // trigger action cancelableSagaError
        var payload = _a.payload;
        console.warn('Reducer type is incorrect: ', payload);
    }, resetState: function (state) {
        Object.assign(state, structuredClone(exports.defaultState));
    }, error401: function (state) {
        state.access = null;
    }, error403: function () {
        // error 403
    }, updateUser: function (state, _a) {
        var payload = _a.payload;
        state.user = payload;
    } }, signIn_1.reducers), signUp_1.reducers), signOut_1.reducers), useMe_1.reducers), { refreshTokenStart: function (state) {
        state.error = null;
        state.loading = true;
    }, refreshTokenSuccess: function (state, _a) {
        var payload = _a.payload;
        Object.assign(state, {
            refreshResponse: payload,
            loading: false,
            authorized: true,
        }, payload);
    }, refreshTokenError: function (state, _a) {
        var payload = _a.payload;
        Object.assign(state, {
            loading: false,
            error: payload,
            authorized: false,
            user: null,
        });
    }, refreshTokenErrorReset: function (state) {
        state.loading = false;
        state.error = null;
    }, refreshTokenClear: function (state) {
        state.loading = false;
        state.refreshResponse = null;
    } })); };
exports.createReducers = createReducers;
/**
 * Action Creators
 * */
var initStore = function (payload) { return ({
    type: config_1.config.actions.initStore.type,
    payload: payload
}); };
exports.initStore = initStore;
/**
 * Sagas
 */
function getState() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(function (state) { return state[config_1.config.auth.name]; })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}
exports.getState = getState;
function updateUserSaga(_a) {
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, (0, effects_1.put)({
                    type: config_1.config.actions.updateUser.type,
                    payload: payload,
                })];
            case 1:
                _b.sent();
                (0, storage_1.startSession)(false);
                return [2 /*return*/];
        }
    });
}
exports.updateUserSaga = updateUserSaga;
function refreshTokenSaga() {
    var refresh, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.put)({
                    type: config_1.config.actions.refreshTokenStart.type,
                })];
            case 1:
                _a.sent();
                return [4 /*yield*/, getState()];
            case 2:
                refresh = (_a.sent()).refresh;
                if (!refresh) return [3 /*break*/, 5];
                return [4 /*yield*/, (0, effects_1.call)(fetchAuthSaga, (0, common_1.createUrl)(config_1.config.refreshToken.url), {
                        method: config_1.config.refreshToken.method,
                        headers: {
                            Authorization: "Bearer ".concat(refresh.token),
                        },
                    })];
            case 3:
                response = (_a.sent());
                return [4 /*yield*/, (0, common_1.defaultResponseProcessing)(response, config_1.config.actions.refreshTokenSuccess.type, config_1.config.actions.refreshTokenError.type, false, function (data) {
                        if (config_1.config.refreshToken.prepareData) {
                            return config_1.config.refreshToken.prepareData(data);
                        }
                        return null;
                    })];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, (0, effects_1.put)({
                    type: config_1.config.actions.refreshTokenError.type,
                    payload: {
                        message: 'Don\'t have refreshToken',
                        status: 401,
                    },
                })];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [2 /*return*/];
        }
    });
}
exports.refreshTokenSaga = refreshTokenSaga;
function initAuthSaga() {
    var access;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getState()];
            case 1:
                access = (_a.sent()).access;
                if (!access) return [3 /*break*/, 3];
                // console.log('lib if access: userMe()');
                return [4 /*yield*/, (0, effects_1.put)((0, useMe_1.userMe)())];
            case 2:
                // console.log('lib if access: userMe()');
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, (0, effects_1.put)({
                    type: config_1.config.actions.resetState.type,
                    payload: 'initAuthSaga'
                })];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
exports.initAuthSaga = initAuthSaga;
/**
 * @param {String} url
 * @param {Object} init
 * @param {Object} options
 * @param {Number} fetchDelay
 *
 * @returns {IterableIterator<Promise<Response>*>}
 */
function fetchAuthSaga(url, init, options, fetchDelay) {
    var access, newInit, headers;
    if (init === void 0) { init = {}; }
    if (options === void 0) { options = {}; }
    if (fetchDelay === void 0) { fetchDelay = config_1.config.fetchDelay; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!fetchDelay) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, effects_1.delay)(fetchDelay)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [4 /*yield*/, getState()];
            case 3:
                access = (_a.sent()).access;
                newInit = __assign({ credentials: 'same-origin' }, init);
                headers = __assign({ Accept: 'application/json' }, (newInit.headers || {}));
                if (access && (options === null || options === void 0 ? void 0 : options.authorization) !== false) {
                    Object.assign(headers, {
                        Authorization: "Bearer ".concat(access.token),
                    });
                }
                newInit.headers = headers;
                return [4 /*yield*/, fetch(url, newInit)];
            case 4: return [2 /*return*/, _a.sent()];
        }
    });
}
exports.fetchAuthSaga = fetchAuthSaga;
/**
 * @param props
 * @param {Number} fetchDelay
 *
 * @returns Promise<Response>
 */
function responseStatus401(props, fetchDelay) {
    function tryAgain() {
        var _a, authorized, error;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getState()];
                case 1:
                    _a = (_b.sent()), authorized = _a.authorized, error = _a.error;
                    if (!(authorized && error === null)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, effects_1.call)(fetchAuthSaga, url, init, options, fetchDelay)];
                case 2: return [2 /*return*/, _b.sent()];
                case 3: return [2 /*return*/, response];
            }
        });
    }
    var response, url, _a, init, _b, options, loading, data, type;
    if (fetchDelay === void 0) { fetchDelay = config_1.config.fetchDelay; }
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                response = props.response, url = props.url, _a = props.init, init = _a === void 0 ? {} : _a, _b = props.options, options = _b === void 0 ? {} : _b;
                return [4 /*yield*/, getState()];
            case 1:
                loading = (_c.sent()).loading;
                if (!loading) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, effects_1.race)({
                        success: (0, effects_1.take)(config_1.config.actions.refreshTokenSuccess.type),
                        error: (0, effects_1.take)(config_1.config.actions.refreshTokenError.type),
                    })];
            case 2:
                _c.sent();
                return [4 /*yield*/, tryAgain()];
            case 3: return [2 /*return*/, _c.sent()];
            case 4: return [4 /*yield*/, (0, effects_1.put)({
                    type: config_1.config.actions.error401.type,
                })];
            case 5:
                _c.sent();
                data = response;
                type = response.headers.get('Content-Type');
                if (!(type === null || (type && type.indexOf('/json') !== -1))) return [3 /*break*/, 7];
                return [4 /*yield*/, response.json()];
            case 6:
                data = (_c.sent());
                _c.label = 7;
            case 7:
                if (!config_1.config.refreshToken.check401(data)) return [3 /*break*/, 10];
                return [4 /*yield*/, refreshTokenSaga()];
            case 8:
                _c.sent();
                return [4 /*yield*/, tryAgain()];
            case 9: return [2 /*return*/, _c.sent()];
            case 10:
                if (!(options.signOut !== false)) return [3 /*break*/, 12];
                // console.log('options.signOut !== false > yield signOutRequestSaga();')
                return [4 /*yield*/, (0, signOut_1.signOutRequestSaga)()];
            case 11:
                // console.log('options.signOut !== false > yield signOutRequestSaga();')
                _c.sent();
                _c.label = 12;
            case 12: return [2 /*return*/, response];
        }
    });
}
/**
 * @param props
 * @param {Number} fetchDelay
 *
 * @returns Promise<Response>
 */
function responseStatus403(props, fetchDelay) {
    var response, url, _a, init, _b, options, data, type, user;
    var _c, _d;
    if (fetchDelay === void 0) { fetchDelay = config_1.config.fetchDelay; }
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                response = props.response, url = props.url, _a = props.init, init = _a === void 0 ? {} : _a, _b = props.options, options = _b === void 0 ? {} : _b;
                return [4 /*yield*/, (0, effects_1.put)({
                        type: config_1.config.actions.error403.type,
                    })];
            case 1:
                _e.sent();
                data = response;
                type = response.headers.get('Content-Type');
                if (!(type === null || (type && type.indexOf('/json') !== -1))) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json()];
            case 2:
                data = (_e.sent());
                _e.label = 3;
            case 3:
                if (!(((_c = data === null || data === void 0 ? void 0 : data.error) === null || _c === void 0 ? void 0 : _c.message) === 'Bad request' && ((_d = data === null || data === void 0 ? void 0 : data.error) === null || _d === void 0 ? void 0 : _d.type) === 'Forbidden')) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, useMe_1.userMeRequestSaga)()];
            case 4:
                _e.sent();
                return [4 /*yield*/, getState()];
            case 5:
                user = (_e.sent()).user;
                if (!(user && user.status === 'active')) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.call)(fetchAuthSaga, url, init, options, fetchDelay)];
            case 6: return [2 /*return*/, _e.sent()];
            case 7: return [2 /*return*/, response];
        }
    });
}
/**
 * @param {String} url
 * @param {Object} init
 * @param {Object} options
 * @param {Number} fetchDelay
 *
 * @returns Promise<Response>
 */
function fetchSaga(url, init, options, fetchDelay) {
    var response, _a, err_1;
    if (init === void 0) { init = {}; }
    if (options === void 0) { options = {}; }
    if (fetchDelay === void 0) { fetchDelay = config_1.config.fetchDelay; }
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 8, , 9]);
                return [4 /*yield*/, (0, effects_1.call)(fetchAuthSaga, url, init, options, fetchDelay)];
            case 1:
                response = (_b.sent());
                _a = response.status;
                switch (_a) {
                    case 401: return [3 /*break*/, 2];
                    case 403: return [3 /*break*/, 4];
                }
                return [3 /*break*/, 6];
            case 2: return [4 /*yield*/, responseStatus401({
                    response: response,
                    url: url,
                    init: init,
                    options: options,
                }, fetchDelay)];
            case 3: return [2 /*return*/, _b.sent()];
            case 4: return [4 /*yield*/, responseStatus403({
                    response: response,
                    url: url,
                    init: init,
                    options: options,
                }, fetchDelay)];
            case 5: return [2 /*return*/, _b.sent()];
            case 6: return [2 /*return*/, response];
            case 7: return [3 /*break*/, 9];
            case 8:
                err_1 = _b.sent();
                return [2 /*return*/, err_1];
            case 9: return [2 /*return*/];
        }
    });
}
exports.fetchSaga = fetchSaga;
function sendRequest(apiFetch, entityName, entity, action) {
    var _a, _b, payload, data, _c, _query, _d, _body, _e, _header, load, response;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _a = action || {}, _b = _a.payload, payload = _b === void 0 ? {} : _b, data = _a.data;
                return [4 /*yield*/, (0, effects_1.put)({
                        type: config_1.config.actions[entityName + 'Start'].type,
                    })];
            case 1:
                _f.sent();
                _c = payload._query, _query = _c === void 0 ? {} : _c, _d = payload._body, _body = _d === void 0 ? {} : _d, _e = payload._header, _header = _e === void 0 ? {} : _e, load = __rest(payload, ["_query", "_body", "_header"]);
                return [4 /*yield*/, (0, effects_1.call)(apiFetch, (0, common_1.createUrl)(entity.url, load, data, _query), {
                        method: entity.method,
                        headers: __assign(__assign({}, entity.headers), _header),
                        body: ['get', 'head', 'delete'].includes((entity.method || '').toLowerCase()) ?
                            undefined
                            :
                                (0, common_1.createRequestBody)(entity, load, data, _body)
                    }, {}, entity.fetchDelay)];
            case 2:
                response = (_f.sent());
                return [4 /*yield*/, (0, common_1.defaultResponseProcessing)(response, config_1.config.actions[entityName + 'Success'].type, config_1.config.actions[entityName + 'Error'].type, false, function (signInData) {
                        if (entity.prepareData) {
                            return entity.prepareData(signInData, load);
                        }
                        return null;
                    })];
            case 3:
                _f.sent();
                return [2 /*return*/];
        }
    });
}
exports.sendRequest = sendRequest;
function updateStorageSaga() {
    var storage, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!config_1.config.auth.storage) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, (0, effects_1.delay)(100)];
            case 1:
                _b.sent();
                _a = [{}];
                return [4 /*yield*/, getState()];
            case 2:
                storage = __assign.apply(void 0, _a.concat([(_b.sent())]));
                window.localStorage.removeItem(config_1.config.auth.storage.name);
                if (typeof window !== 'undefined' && window.localStorage) {
                    storage.error = null;
                    storage.loading = false;
                    storage.init = false;
                    window.localStorage.setItem(config_1.config.auth.storage.name, JSON.stringify(storage));
                }
                return [2 /*return*/];
        }
    });
}
exports.updateStorageSaga = updateStorageSaga;
function updateState(store) {
    if (typeof window !== 'undefined' && window.localStorage) {
        window.addEventListener('DOMContentLoaded', function () {
            window.addEventListener('storage', function (event) {
                if (config_1.config.auth.storage && event.key === config_1.config.auth.storage.name) {
                    store.dispatch({
                        type: config_1.config.actions.update.type,
                        payload: store.getState()[config_1.config.auth.name]
                    });
                }
            });
        });
    }
}
exports.updateState = updateState;
function saga(store) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.spawn)(initAuthSaga)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.spawn)(signIn_1.saga)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.spawn)(signUp_1.saga)];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.spawn)(useMe_1.saga)];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.spawn)(signOut_1.saga)];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(signOut_1.checkRememberStatusAndSignOut, store)];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(updateState, store)];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(config_1.config.actions.signInSuccess.type, function trigger() {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, (0, effects_1.put)((0, useMe_1.userMe)())];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    })];
            case 8:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(config_1.config.actions.refreshTokenError.type, function trigger(_a) {
                        var payload = _a.payload;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!(payload && payload.status === 403)) return [3 /*break*/, 2];
                                    console.log(123123123, 'yield put(signOut(payload));');
                                    return [4 /*yield*/, (0, effects_1.put)((0, signOut_1.signOut)(payload))];
                                case 1:
                                    _b.sent();
                                    _b.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    })];
            case 9:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(config_1.config.actions.refreshTokenSuccess.type, function clear() {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!config_1.config.delaySuccess) return [3 /*break*/, 2];
                                    return [4 /*yield*/, (0, effects_1.delay)(config_1.config.delaySuccess)];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2: return [4 /*yield*/, (0, effects_1.put)({
                                        type: config_1.config.actions.refreshTokenClear.type,
                                    })];
                                case 3:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    })];
            case 10:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(config_1.config.actions.refreshTokenError.type, function clear() {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!config_1.config.delayError) return [3 /*break*/, 2];
                                    return [4 /*yield*/, (0, effects_1.delay)(config_1.config.delayError)];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2: return [4 /*yield*/, (0, effects_1.put)({
                                        type: config_1.config.actions.refreshTokenErrorReset.type,
                                    })];
                                case 3:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    })];
            case 11:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)([
                        config_1.config.actions.initStore.type,
                        config_1.config.actions.updateUser.type,
                        config_1.config.actions.signInSuccess.type,
                        config_1.config.actions.signInClear.type,
                        config_1.config.actions.signOutSuccess.type,
                        config_1.config.actions.userMeSuccess.type,
                        config_1.config.actions.error401.type,
                        config_1.config.actions.refreshTokenSuccess.type,
                        config_1.config.actions.refreshTokenError.type,
                    ], updateStorageSaga)];
            case 12:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.saga = saga;
